<template>
    <div>
        <MainHeader />
        <div
            v-bind:class="[
                {
                    [$style.veticalPadding]: !disableVerticalPadding,
                    [$style.horizontalPadding]: !disableHorizontalPadding,
                },
                $style.body,
            ]"
        >
            <slot></slot>
        </div>
        <div v-bind:class="$style.footer">
            <AppLink
                v-bind:to="{
                    path: '/privacy',
                }"
            >Privacy Policy</AppLink>
        </div>
    </div>
</template>

<script>
    import MainHeader from '@components/MainHeader';

    export default {
        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            MainHeader,
        },

        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            disableVerticalPadding: {
                type: Boolean,
                default: false,
            },
            disableHorizontalPadding: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .body {
        @apply w-full overflow-hidden;
    }

    .veticalPadding {
        @apply py-6;
    }

    .horizontalPadding {
        @apply px-10;
    }

    .footer {
        @apply p-4;
        border-top: 1px solid gray;
    }
</style>
